const positionKey = "planroomProjectPosition";

/** Keep dashboard/board navigation in this document, including direct board links. */
export function projectHistory(
  view: Pick<
    Window,
    "history" | "location" | "addEventListener" | "removeEventListener"
  >,
  navigate: (url: URL) => void,
  canLeave: () => boolean,
  dashboardPath = "/",
) {
  const { history, location } = view;
  let position: number = history.state?.[positionKey] ?? 0;
  if (history.state?.[positionKey] === undefined) {
    const initial = location.href;
    const isBoard = new URL(initial).searchParams.has("room");
    history.replaceState(
      { ...history.state, [positionKey]: 0 },
      "",
      isBoard ? dashboardPath : initial,
    );
    if (isBoard) {
      position = 1;
      history.pushState({ [positionKey]: position }, "", initial);
    }
  }
  const pop = () => {
    const target = history.state?.[positionKey];
    if (typeof target !== "number") return;
    if (target !== position && !canLeave()) {
      history.go(position - target);
      return;
    }
    // A rejected traversal is being restored; leave the mounted board alone.
    if (target === position) return;
    position = target;
    navigate(new URL(location.href));
  };
  view.addEventListener("popstate", pop);
  return {
    write(url: string, replace = false) {
      if (replace)
        history.replaceState(
          { ...history.state, [positionKey]: position },
          "",
          url,
        );
      else history.pushState({ [positionKey]: ++position }, "", url);
    },
    dispose() {
      view.removeEventListener("popstate", pop);
    },
  };
}
